import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetMenuListSlice = createSlice({
    name: "getMenu",
    initialState,
    reducers: {
        getMenuRequest(state) {
            state.loading = true;
        },
        getMenuRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getMenuRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getMenuRequest,
    getMenuRequestSuccess,
    getMenuRequestError,
} = GetMenuListSlice.actions;

export default GetMenuListSlice.reducer;
